/* eslint-disable */
import React, { Fragment, useState } from "react";

export default (props) => {
  const {
    title,
    description,
    confirm,
    thumbnail,
    close,
    sub,
    account,
    phone,
    number,
  } = props;

  const [isOpen, setOpen] = useState(true);

  /**
   * Close Banner
   */
  const closeNotification = () => {
    setOpen(false);
  };

  const setLocalStorage = () => {
    localStorage.setItem("phoneOk", true);
    setOpen(false);
  };

  return (
    <>
      {!localStorage.getItem("phoneOk") && sub && isOpen ? (
        <div className="notification">
          <div className="notification__content">
            <div className="notification__left">
              <div className="notification__logo">
                <img src={thumbnail} />
              </div>

              <div className="notification__text">
                <h3>
                  {title} <span>{phone || number}</span>
                </h3>
                <div className="notification__confirmations">
                  {phone && (
                    <span>
                      <a onClick={setLocalStorage} href="#">
                        {confirm}
                      </a>
                    </span>
                  )}

                  <span>
                    <a href={account}>{description}</a>
                  </span>
                </div>
              </div>
            </div>

            <div className="notification__right">
              <span className="close" onClick={closeNotification}>
                <img src={close} />
              </span>
            </div>
          </div>
        </div>
      ) : !localStorage.getItem("phoneOk") && isOpen ? (
        <div className="notification">
          <div className="notification__content">
            <div className="notification__left">
              <div className="notification__logo">
                <img src={thumbnail} />
              </div>

              <div className="notification__text">
                <h3>{title}</h3>
                <p>{description}</p>
              </div>
            </div>

            <div className="notification__right">
              <span className="close" onClick={closeNotification}>
                <img src={close} />
              </span>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
